// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { ContextualMenu, DirectionalHint } from '@fluentui/react';
import React, { useMemo } from 'react';
import { chatMessageMenuStyle, menuIconStyleSet, menuItemIncreasedSizeStyles } from '../styles/ChatMessageComponent.styles';
/**
 * Chat message actions flyout that contains actions such as Edit Message, or Remove Message.
 *
 * @private
 */
export const ChatMessageActionFlyout = (props) => {
    const menuItems = useMemo(() => [
        {
            key: 'Edit',
            text: props.strings.editMessage,
            itemProps: { styles: props.increaseFlyoutItemSize ? menuItemIncreasedSizeStyles : undefined },
            iconProps: { iconName: 'MessageEdit', styles: menuIconStyleSet },
            onClick: props.onEditClick
        },
        {
            key: 'Remove',
            text: props.strings.removeMessage,
            itemProps: { styles: props.increaseFlyoutItemSize ? menuItemIncreasedSizeStyles : undefined },
            iconProps: {
                iconName: 'MessageRemove',
                styles: menuIconStyleSet
            },
            onClick: props.onRemoveClick
        }
    ], [
        props.increaseFlyoutItemSize,
        props.onEditClick,
        props.onRemoveClick,
        props.strings.editMessage,
        props.strings.removeMessage
    ]);
    // gap space uses pixels
    return (React.createElement(ContextualMenu, { alignTargetEdge: true, gapSpace: 5 /*px*/, isBeakVisible: false, items: menuItems, hidden: props.hidden, target: props.target, onDismiss: props.onDismiss, directionalHint: DirectionalHint.topRightEdge, className: chatMessageMenuStyle }));
};
//# sourceMappingURL=ChatMessageActionsFlyout.js.map